import { render, staticRenderFns } from "./PropertyForm.vue?vue&type=template&id=33b87df8&scoped=true&"
import script from "./PropertyForm.vue?vue&type=script&lang=js&"
export * from "./PropertyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b87df8",
  null
  
)

export default component.exports